<template>
  <div>
    <div class="selector">
      <span class="icon-checkmark-circle" v-bind:class="{ active: institutionNumberConfirmed }"></span>
      Institutionsnummer
    </div>
    <div>
      Bekræft dit institutionsnummer
      850999
      <button @click="institutionNumberConfirmedClick">Ja det er korrekt</button>
    </div>

    <div class="selector">
      <span class="icon-checkmark-circle" v-bind:class="{ active: dataAgreementConfirmed }"></span>
      Dataaftale godkendt
    </div>
    <div>
      Din skole har godkendt dataaftalen.
      Din skole har ikke godkendt dataaftalen.
    </div>

    <div class="selector">
      <span class="icon-checkmark-circle" v-bind:class="{ active: locationsConfirmed }"></span>
      Lokaler oprettet i Aula
    </div>
    <div>
      Lokaler er oprettet i Aula
      <button @click="locationsConfirmedClick">Ja det er korrekt</button>
    </div>

    <div class="selector">
      <span class="icon-checkmark-circle" v-bind:class="{ active: usersImported }"></span>
      Brugere importeret
    </div>
    <div>
      35 ud af 45 brugere er importeret.
      <button @click="usersImportedClick">Vis brugere der kan importeres</button>
    </div>

    <div class="selector">
      <span class="icon-checkmark-circle" v-bind:class="{ active: groupsImported }"></span>
      Grupper importeret
    </div>
    <div>
      15 ud af 18 grupper er importeret.
      <button @click="groupsImportedClick">Vis grupper der kan importeres</button>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'aula-setup',
    description: 'Initial setup of Aula for a school.',
    data () {
      return {
        institutionNumberConfirmed: false,
        dataAgreementConfirmed: false,
        locationsConfirmed: false,
        usersImported: false,
        groupsImported: false
      }
    },
    methods: {
      institutionNumberConfirmedClick () {
        this.institutionNumberConfirmed = true
      },
      locationsConfirmedClick () {
        this.locationsConfirmed = true
      },
      usersImportedClick () {
        this.usersImported = true
      },
      groupsImportedClick () {
        this.groupsImported = true
      }
    }
  }
</script>

<style scoped>
  .active {
    color: #4CAF50
  }

  .selector {
    font-size: 30px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// Setup.vue?10131774